import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Loader2, Download, Upload, RotateCcw } from "lucide-react";
import { TOKEN_KEY } from "../lib/mw";
import { toast } from "sonner";

const fmt = (iso) => new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function ReleasesSettings() {
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/releases").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const create = async () => {
    setBusy(true);
    try { const r = await api.post("/releases", { data: { name, desc } }); toast.success(`SÜRÜM ${r.data.version} KAYDEDİLDİ — ${r.data.total.toLocaleString("tr-TR")} KAYIT YEDEKLENDİ`); setName(""); setDesc(""); load(); }
    finally { setBusy(false); }
  };

  const download = async (r) => {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/releases/${r.id}/download`, { headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` } });
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement("a"); a.href = url; a.download = `yedek-${r.version}.zip`; a.click(); URL.revokeObjectURL(url);
  };

  const restore = async (r) => {
    const password = window.prompt(`${r.version} YEDEĞİNDEN SADECE ŞU AN SİSTEMDE OLMAYAN KAYITLAR GERİ EKLENİR. MEVCUT VERİLERE DOKUNULMAZ, HİÇBİR ŞEY SİLİNMEZ.\n\nONAY İÇİN GİRİŞ ŞİFRENİZİ YAZIN:`);
    if (!password) return;
    const res = await api.post(`/releases/${r.id}/restore-missing`, { data: { password } });
    toast.success(res.data.total ? `${res.data.total.toLocaleString("tr-TR")} EKSİK KAYIT GERİ EKLENDİ` : "EKSİK KAYIT YOK — VERİLER TAM");
  };

  return (
    <div data-testid="releases-settings" className="space-y-3">
      <div className="rounded-lg border border-slate-800 bg-slate-900 p-3">
        <div className="mb-2 text-sm font-bold text-white">SÜRÜM YÜKLE</div>
        <p className="mb-2 text-xs text-slate-400">KAYDEDİLEN HER SÜRÜMDE SİSTEMDEKİ BÜTÜN VERİLERİN (TÜM FİRMALAR) YEDEĞİ ALINIR.</p>
        <div className="flex gap-2">
          <Input data-testid="release-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="GELİŞTİRMENİN ADI" className="h-9 border-slate-700 bg-slate-800" />
          <Input data-testid="release-desc-input" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="AÇIKLAMA" className="h-9 border-slate-700 bg-slate-800" />
          <Button data-testid="release-create-button" disabled={busy || !name.trim()} onClick={create} className="h-9 shrink-0 bg-blue-600 text-white hover:bg-blue-700">
            {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Upload className="mr-1 h-4 w-4" />} SÜRÜM YÜKLE + YEDEKLE
          </Button>
        </div>
      </div>
      <div className="overflow-auto rounded-lg border border-slate-800">
        <table data-testid="releases-table" className="w-full text-xs">
          <thead className="bg-slate-900 text-left text-slate-400"><tr><th className="px-2 py-1.5">TARİH</th><th className="px-2">SÜRÜM</th><th className="px-2">GELİŞTİRME</th><th className="px-2">AÇIKLAMA</th><th className="px-2">YEDEK</th><th className="px-2" /></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={6} className="px-2 py-4 text-center text-slate-500">HENÜZ SÜRÜM YOK</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`release-row-${r.version}`} className="border-t border-slate-800 text-slate-200">
                <td className="px-2 py-1">{fmt(r.date)}</td>
                <td className="px-2 font-bold text-blue-300">{r.version}</td>
                <td className="px-2 font-bold">{r.name}</td>
                <td className="px-2 text-slate-400">{r.desc}</td>
                <td className="px-2 text-emerald-400">YEDEK VAR · {r.total.toLocaleString("tr-TR")} KAYIT</td>
                <td className="flex gap-1 px-2 py-1">
                  <Button data-testid={`release-download-${r.version}`} onClick={() => download(r)} className="h-7 bg-slate-700 px-2 text-xs hover:bg-slate-600"><Download className="mr-1 h-3.5 w-3.5" /> İNDİR</Button>
                  <Button data-testid={`release-restore-${r.version}`} onClick={() => restore(r)} className="h-7 bg-amber-700 px-2 text-xs hover:bg-amber-600"><RotateCcw className="mr-1 h-3.5 w-3.5" /> EKSİKLERİ GERİ GETİR</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
